import { render, staticRenderFns } from "./CPU.vue?vue&type=template&id=78061ce0&scoped=true"
import script from "./CPU.vue?vue&type=script&lang=js"
export * from "./CPU.vue?vue&type=script&lang=js"
import style0 from "./CPU.vue?vue&type=style&index=0&id=78061ce0&prod&scoped=true&lang=css"
import style1 from "./CPU.vue?vue&type=style&index=1&id=78061ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78061ce0",
  null
  
)

export default component.exports